import type { NavigateFunction } from "react-router-dom";

export const DRIVE_PATH = "/drive";

/** Passed via `navigate(DRIVE_PATH, { state })`: open the create/share folder modal, or search for a file in its folder. */
export type DriveLocationState = {
  openUploadModal?: boolean;
  prefillWorksheetImage?: string;
  search?: string;
  /** The folder to open, as `buildFolderSelectionKey` names it */
  folder?: string;
};

export const DRIVE_OPEN_UPLOAD_MODAL_STATE: DriveLocationState = {
  openUploadModal: true,
};

export function navigateToDriveUpload(navigate: NavigateFunction): void {
  navigate(DRIVE_PATH, { state: DRIVE_OPEN_UPLOAD_MODAL_STATE });
}

/** Drive's upload, as `navigateToDriveUpload` opens it, for code that hands over a route instead (e.g. Ask Noticeboard). */
export const toDriveUpload = () => ({ pathname: DRIVE_PATH, state: DRIVE_OPEN_UPLOAD_MODAL_STATE });

/** Drive searched for a file by name, with its folder open if it's in one. */
export const toDriveSearch = (
  search: string,
  folder?: string,
): { pathname: string; state: DriveLocationState } => ({
  pathname: DRIVE_PATH,
  state: folder ? { search, folder } : { search },
});
